.table {
  background: var(--surface-raised);
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
}

.row {
  display: flex;
  gap: var(--space-4);
  padding: var(--space-4);
  border-block-end: 1px solid var(--border);
}

.row:last-child {
  border-block-end: 0;
}

.wide {
  flex: 2;
}

.narrow {
  flex: 1;
}

.srOnly {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
